import { bottomMenuItems, menuItems, nonMenuItems } from '@/constant/navigations';
import { ROUTES } from '@/constant/routes';

const AUTH_PAGE_TITLES: Array<{ url: string; title: string; exact?: boolean }> =
  [
    { url: ROUTES.SIGNIN, title: 'Sign In', exact: true },
    { url: ROUTES.INVITE_ACCEPT, title: 'Invite', exact: true },
    { url: '/forgot-password', title: 'Forgot Password', exact: true },
    { url: '/reset-password', title: 'Reset Password', exact: true },
    { url: '/signup/verify', title: 'Verify Email', exact: true },
    { url: ROUTES.REGISTER, title: 'Register', exact: true },
    { url: '/signup/join', title: 'Join Company', exact: true },
    { url: ROUTES.COMPANY_PENDING, title: 'Pending Approval', exact: true },
    { url: ROUTES.COMPANY_BC_SETUP, title: 'BigChange Setup', exact: true },
    { url: ROUTES.COMPANY_CREATE, title: 'Create Company', exact: true },
    { url: '/signup', title: 'Sign Up' },
  ];

export function getPageTitle(pathname: string): string {
  const items = [
    ...menuItems,
    ...bottomMenuItems,
    ...nonMenuItems,
    ...AUTH_PAGE_TITLES,
  ];

  const match = items
    .filter(item => {
      if (item.url === '/' || ('exact' in item && item.exact)) {
        return pathname === item.url;
      }
      return pathname === item.url || pathname.startsWith(`${item.url}/`);
    })
    .sort((a, b) => b.url.length - a.url.length)[0];

  return match?.title ?? '404';
}

export function getDocumentTitle(pathname: string): string {
  return `VH3 AI - ${getPageTitle(pathname)}`;
}
